import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export const TaglineMoment = () => (
  <section className="relative overflow-hidden bg-ink text-cream" data-testid="tagline-moment-section">
    <motion.div
      initial={{ scale: 1.15, opacity: 0 }}
      whileInView={{ scale: 1, opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 1.4, ease: "easeOut" }}
      className="absolute inset-0"
    >
      <img src="/images/social/social-3.jpg" alt="" aria-hidden="true" loading="lazy"
        className="w-full h-full object-cover opacity-25 saturate-[.7]" />
      <div className="absolute inset-0 bg-gradient-to-b from-ink via-ink/40 to-ink" />
    </motion.div>

    <div className="relative max-w-6xl mx-auto px-4 sm:px-6 py-24 sm:py-36 text-center">
      <motion.p
        initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="text-xs font-bold tracking-[0.3em] uppercase text-cream/60 mb-8"
      >
        The Roamies promise
      </motion.p>
      <h2 className="font-display uppercase leading-[0.92]" data-testid="tagline-moment-heading">
        <motion.span
          initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
          className="block text-5xl sm:text-7xl lg:text-8xl xl:text-9xl"
        >
          Show up solo.
        </motion.span>
        <motion.span
          initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="block text-5xl sm:text-7xl lg:text-8xl xl:text-9xl text-outline-cream mt-2"
        >
          Leave with <span className="text-flame" style={{ WebkitTextStroke: 0 }}>a family.</span>
        </motion.span>
      </h2>
      <motion.div
        initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.75 }}
      >
        <a href="#waitlist" data-testid="tagline-moment-cta"
          className="group inline-flex items-center gap-3 mt-12 bg-flame hover:bg-flame/90 text-white h-14 px-10 font-bold uppercase tracking-[0.2em] text-sm transition-all hover:-translate-y-0.5 shadow-[0_0_30px_rgba(255,69,0,0.25)]">
          Join the waitlist
          <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
        </a>
      </motion.div>
    </div>
  </section>
);
